document.addEventListener('DOMContentLoaded', function () {
  var tabs = document.querySelectorAll('.tab-item');
  var bottomTabNav = document.querySelector('.bottom-tab-nav');

  var pathsToShow = ['/', '/account', '/cart', '/search'];

  function updateTabNavVisibility() {
    if (pathsToShow.includes(window.location.pathname)) {
      if (window.innerWidth <= 768) {
        bottomTabNav.style.display = 'flex'; // Show on mobile
      } else {
        bottomTabNav.style.display = 'none'; // Hide on desktop
      }
    } 
  }

  updateTabNavVisibility(); // Initial check
  window.addEventListener('resize', updateTabNavVisibility); // Re-check on resize

  tabs.forEach(function (tab) {
    if (tab.pathname === window.location.pathname) {
      tab.classList.add('active');
    }
  });
});
